if (!customElements.get('product-specs')) {
  class ProductSpecs extends HTMLElement {
    constructor () {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }
    connectedCallback () {
      this.specs = this.querySelectorAll('.variant-spec');
      document.addEventListener('variant:change', this.handleVariantChange);
    }

    disconnectedCallback () {
      document.removeEventListener('variant:change', this.handleVariantChange);
    }

    handleVariantChange (event) {
      const current_variant_id = event.detail.variant.id.toString();
      if (current_variant_id && this.specs) {
        this.specs.forEach(spec => {
          const spec_variant_id = spec.getAttribute('data-variant-id');
          if (spec_variant_id === current_variant_id) {
            spec.classList.remove('hidden');
          } else {
            spec.classList.add('hidden');
          }
        });
      }
    }
  }

  customElements.define('product-specs', ProductSpecs);
}